import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { useEffect } from 'react';
import { Badge } from "@/components/ui/badge";

const ActionStep = ({ stepKey, updateStepData, getStepData }) => {
    const stepData = getStepData(stepKey);

    useEffect(() => {
        if (stepData) {
            updateStepData(stepKey, stepData);
        }
    }, []);

    return (
        <div className="flex flex-col space-y-8 items-center">
            <div className="flex flex-col items-center space-y-3">
                <h1 className="font-semibold text-3xl text-center">Action Type</h1>
                <p className="text-center text-muted-foreground">Choose the type of monitor you would like to configure</p>
            </div>
            <RadioGroup
                defaultValue={stepData}
                onValueChange={(value) => {
                    updateStepData(stepKey, value);
                }}
                className="w-full max-w-lg mx-auto flex flex-col space-y-3"
            >
                <label className={`flex items-center space-x-6 p-6 border rounded-lg cursor-pointer ${stepData === 'ping' ? 'scale-105 border-violet-500 active:scale-[1.04]' : 'scale-100 border-neutral-700 hover:scale-[1.01] active:scale-[0.99]'} transform transition-all duration-200`}>
                    <RadioGroupItem value="ping" id="r1" />
                    <Label htmlFor="r1" className="cursor-pointer">
                        <h4 className="font-semibold mb-1">HTTP Ping</h4>
                        <p className="text-xs text-muted-foreground">Ping a URL to check its response</p>
                    </Label>
                </label>
                <label className={`flex items-center space-x-6 p-6 border rounded-lg cursor-pointer ${stepData === 'browser_agent' ? 'scale-105 border-violet-500 active:scale-[1.04]' : 'scale-100 border-neutral-700 hover:scale-[1.01] active:scale-[0.99]'} transform transition-all duration-200`}>
                    <RadioGroupItem value="browser_agent" id="r2" />
                    <Label htmlFor="r2" className="cursor-pointer">
                        <div className="flex items-center gap-2">
                            <h4 className="font-semibold mb-1">Browser Agent</h4>
                            <Badge variant="secondary" className="bg-violet-100 text-violet-800 dark:bg-violet-950 text-violet-400 text-[10px] px-1.5 py-0.5 mb-1">Beta</Badge>
                        </div>
                        <p className="text-xs text-muted-foreground">AI assisted browser interactions to monitor web applications</p>
                    </Label>
                </label>
                <label className={`flex items-center space-x-6 p-6 border rounded-lg cursor-not-allowed opacity-50 ${stepData === 'ocapi' ? 'scale-105 border-violet-500' : 'scale-100 border-neutral-700'} transform transition-all duration-200`}>
                    <RadioGroupItem value="ocapi" id="r3" disabled />
                    <Label htmlFor="r3" className="cursor-not-allowed">
                        <div className="flex items-center gap-2">
                            <h4 className="font-semibold mb-1">Ecommerce Orders</h4>
                            <Badge variant="secondary" className="bg-neutral-200 text-neutral-800 dark:bg-neutral-800 dark:text-neutral-200 text-[10px] px-1.5 py-0.5 hover:bg-neutral-800/50">Coming Soon</Badge>
                        </div>
                        <p className="text-xs text-muted-foreground">Monitor order flow and status from popular ecommerce platforms</p>
                    </Label>
                </label>
            </RadioGroup>
        </div>
    );
};

export default ActionStep;